<template>
  <!-- 2018-5-24 09:43:43 扩展了一个带最大长度限制的显示，暂未使用 -->
  <div class="pagoda-textarea-cell">
    <el-input
      type="textarea"
      v-bind="$attrs"
      v-on="$listeners"
      v-model="valueTmpl"
      >
    </el-input>
    <span class="letter_counter text-gray fz12" v-if="$attrs.maxlength">
      <span :class="getLengthClass(valueTmpl.length, $attrs.maxlength)">
      {{valueTmpl.length}}</span>/{{$attrs.maxlength}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TextareaCell',
  data () {
    return {
      valueTmpl: this.value || ''
    }
  },
  props: {
    value: String
  },
  watch: {
    value (val) { // 实现双向数据绑定
      this.valueTmpl = val
    }
  },
  methods: {
    getLengthClass (length, max) {
      return {
        'text-danger': +max < +length,
        'text-blue': +max === +length
      }
    }
  }
}
</script>
